import Men from '../assets/GiftAsset/men.jpg';
import Women from '../assets/GiftAsset/women.jpg';
import Wedding from '../assets/GiftAsset/wedding.jpg';
import Seasonal from '../assets/GiftAsset/seasonal.jpg';
import Birthday from '../assets/GiftAsset/birthday.jpg';
import Kids from '../assets/GiftAsset/kids.jpg';
import CourseItem from '../assets/DigitalCoursesAsset/CourseItem.jpg'
import CourseItem2 from '../assets/DigitalCoursesAsset/CourseItem3.jpg'
import CourseItem3 from '../assets/DigitalCoursesAsset/CourseItem3.jpg'
import CourseItem4 from '../assets/DigitalCoursesAsset/CourseItem4.jpg'
import CourseItem5 from '../assets/DigitalCoursesAsset/CourseItem5.jpg'
import CourseItem6 from '../assets/DigitalCoursesAsset/CourseItem6.jpg';
import GiftItem1 from '../assets/GiftAsset/GiftItem.jpg';
import GiftItem2 from '../assets/GiftAsset/GiftItem1.jpg';
import GiftItem3 from '../assets/GiftAsset/GiftItem2.jpg';
import ManufaturerDp from '../assets/GiftAsset/ManufacturerDp.jpg'


export const CourseCategories = [
    {
        description:'Business And Entrepreneurship',
        
    },
    {
        description :'Technology And Programming',
       
    },
    {
      description:'Creative Arts & Design',
    
    },
    {
      description:'Fashion & Beauty',
      
    },
    {
      description:'Finance & Investments',
    
    },
    {
      description:'Digital Marketing & Content Creation',
      
    },
    {
      description:'Health & Wellness',
    
  },
]

export const GiftCategories = [
    {
        title:'For Him',
        image: Men,
    },
    {
        title:'For Her',
        image: Women
    },
    {
        title:'Wedding Gifts',
        image: Wedding
    },
    {
        title:'Season Specials',
        image: Seasonal
    },
    {
        title:'For Kids',
        image: Kids
    },
    {
        title:'Birthday Gifts',
        image: Birthday
    },
]

  // Sample course data (you can fetch this from an API or database)
  export const courses =[ {
    id:'0',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'1',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'2',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'3',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'4',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'5',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'6',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'7',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'8',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'9',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'10',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
  {
    id:'11',
    name: 'Mastering Social Media Marketing',
    description: 'Learn how to create impactful social media campaigns that convert leads into customers. Perfect for aspiring marketers and business owners.',
    price: '₦15,000',
    avalPrice: '₦63,234.03',
    category:'Fashion & Beauty',
    duration: '6',
    format: 'video and pdf materials',
    certificate: 'yes, upon completion',
    images: [
      CourseItem,
      CourseItem2,
      CourseItem3,
      CourseItem4,
      CourseItem5,
      CourseItem6
    ],
  },
];

// Samples gifts which would be fetched from the API
export const gifts =[ {
  id:'0',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'1',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'2',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'3',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'4',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'5',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'6',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'7',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'8',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'9',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'10',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'11',
  name: 'Luxury Flower Bouquet',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
];

export const cart__items =[ {
  id:'0',
  name: 'Luxury Flower Bouquet',
  quantity:1,
  sub_description:'Seasonal blooms for all occasions.',
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'1',
  name: 'Luxury Flower Bouquet',
  sub_description:'Personalized with initials.',
  quantity:1,
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{
  id:'2',
  name: 'Luxury Flower Bouquet',
  sub_description:'Seasonal blooms for all occasions.',
  quantity:1,
  manufacturer:{
    name:'Lush & Green Stores',
    image:ManufaturerDp
  },
  description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
  price: '₦10,000',
  avalPrice: '₦63,234.03',
  specification: [
    {
      Label:'Size',
      Value:'Medium'
    }
  ],
  images: [
    GiftItem1,
    GiftItem2,
    GiftItem3,
  ],
},
{id:'1',
name: 'Luxury Flower Bouquet',
sub_description:'Personalized with initials.',
quantity:1,
manufacturer:{
  name:'Lush & Green Stores',
  image:ManufaturerDp
},
description: 'A beautiful arrangement of seasonal flowers, handpicked for freshness and fragrance.',
price: '₦10,000',
avalPrice: '₦63,234.03',
specification: [
  {
    Label:'Size',
    Value:'Medium'
  }
],
images: [
  GiftItem1,
  GiftItem2,
  GiftItem3,
],
},
]

export const order_data = [
  {
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'failed',
  order_item:{
    address:'178 Abraham Adesanya Road, Ajah, Lagos',
    tracking_number:'md-1234567',
    product_name:'Luxury Flower Bouquet',
    product_image:GiftItem2,
    quantity:2,
    price:'₦10,000.00',
    total:'₦20,000.00'
  },
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'shipped',
  order_item:{
    address:'178 Abraham Adesanya Road, Ajah, Lagos',
    tracking_number:'md-1234567',
    product_name:'Luxury Flower Bouquet',
    product_image:GiftItem1,
    quantity:2,
    price:'₦10,000.00',
    total:'₦20,000.00'
  },
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'completed',
  order_item:{
    address:'178 Abraham Adesanya Road, Ajah, Lagos',
    tracking_number:'md-1234567',
    product_name:'Luxury Flower Bouquet',
    product_image:GiftItem1,
    quantity:2,
    price:'₦10,000.00',
    total:'₦20,000.00'
  },
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'shipped',
  order_item:{
    address:'178 Abraham Adesanya Road, Ajah, Lagos',
    tracking_number:'md-1234567',
    product_name:'Luxury Flower Bouquet',
    product_image:GiftItem1,
    quantity:2,
    price:'₦10,000.00',
    total:'₦20,000.00'
  },
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'failed',
  order_item:{
    address:'178 Abraham Adesanya Road, Ajah, Lagos',
    tracking_number:'md-1234567',
    product_name:'Luxury Flower Bouquet',
    product_image:GiftItem1,
    quantity:2,
    price:'₦10,000.00',
    total:'₦20,000.00'
  },
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'completed',
  order_item:{
    address:'178 Abraham Adesanya Road, Ajah, Lagos',
    tracking_number:'md-1234567',
    product_name:'Luxury Flower Bouquet',
    product_image:GiftItem1,
    quantity:2,
    price:'₦10,000.00',
    total:'₦20,000.00'
  },
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'shipped',
  order_item:{
    address:'178 Abraham Adesanya Road, Ajah, Lagos',
    tracking_number:'md-1234567',
    product_name:'Luxury Flower Bouquet',
    product_image:GiftItem1,
    quantity:2,
    price:'₦10,000.00',
    total:'₦20,000.00'
  },
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
]

export const course_order_data = [
  {
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'failed',
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'shipped',
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'completed',
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'shipped',
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'failed',
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'completed',
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
{
  order_id:'#md-123456',
  category:'gift shop',
  date_time:'31/12/2024 ; 12:49Pm',
  total:'₦10,000.00',
  balance:'₦10,000.00',
  status:'shipped',
  others:{
    subtotal: '₦10,000.00',
    discount: '₦10,000.00',
    delivery_fee:'₦10,000.00',
    grand_total: '₦10,000.00'
  }
},
]
